class Inputs {
  query = '';
  
  constructor(query) {
    this.query = query;
  }
}

export default Inputs;
